var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableGradient',{attrs:{"icon-name":"ticket-alt","title":_vm.$t('container_support.listagem_etiquetas'),"text-empty":_vm.$t('container_support.etiqueta_nao_encontrada'),"fields":_vm.fields,"items":_vm.containers,"paginator":_vm.paginator,"loading":_vm.isLoading,"table-data":""},on:{"list":function (evt) { return _vm.$store.dispatch('container_support/listAll', evt); }},scopedSlots:_vm._u([{key:"cell(status)",fn:function(ref){
var status = ref.item.status;
return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip:hover",arg:"hover"}],class:{
      'rounded-pill p-1 badge ': true,
      'badge-success': status === 'available',
      'badge-danger': status === 'canceled',
      'badge-warning': status === 'pending',
      'badge-primary': status === 'used'
    },attrs:{"title":_vm.getStatusString(status)}},[_c('i',{class:{
        'fas ': true,
        'fa-check': status === 'available',
        'fa-ban': status === 'canceled',
        'fa-exclamation': status === 'pending',
        'fa-vial': status === 'used'
      }})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }